import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Projects from './pages/Projects.jsx';
import Datenschutz from './pages/Datenschutz.jsx';
import Impressum from './pages/Impressum.jsx';
import Digimon from './pages/Digimon.jsx';
import Pokemon from './pages/Pokemon.jsx';

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
  }, [darkMode]);

  const toggleTheme = () => {
    setDarkMode((prev) => !prev);
  };

  return (
    <div className="App">
      <div className="theme-toggle-shell">
        <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle dark mode">
          {darkMode ? 'Light Mode' : 'Dark Mode'}
        </button>
      </div>

      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/digimon" element={<Digimon darkMode={darkMode} />} />
          <Route path="/pokemon" element={<Pokemon darkMode={darkMode} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
